import {INTRODUCE_ROOT, INTRODUCE_INDEX, INTRODUCE_APPLY_ENTRANCE, INTRODUCE_APPLY_RESULT} from '@/enmus/PageNames';
const IntroduceRoot = () => import('@/views/introduce/index.vue');
const IntroduceIndex = () => import('@/views/introduce/Introduce.vue');
// const ApplyEntrance = () => import('@/views/introduce/ApplyEntrance.vue');
// const ApplyRes = () => import('@/views/introduce/ApplyRes.vue');
export default {
    component: IntroduceRoot,
    path: 'introduce',
    name: INTRODUCE_ROOT,
    meta: {
        name: INTRODUCE_ROOT,
        title: '产品介绍'
    },
    children: [{
        path: 'index',
        name: INTRODUCE_INDEX,
        component: IntroduceIndex,
        meta: {
            name: INTRODUCE_INDEX,
            title: '产品介绍'
        }
    }]
    // {
    //     path: 'apply',
    //     name: INTRODUCE_APPLY_ENTRANCE,
    //     component: ApplyEntrance,
    //     meta: {
    //         name: INTRODUCE_APPLY_ENTRANCE,
    //         title: '权限申请'
    //     }
    // }, {
    //     path: 'result',
    //     name: INTRODUCE_APPLY_RESULT,
    //     component: ApplyRes,
    //     meta: {
    //         name: INTRODUCE_APPLY_RESULT,
    //         title: '申请结果'
    //     }
    // }
};